import { useContext, useEffect } from 'react';
import { FrameContext } from 'react-frame-component';

const defaultEvents = ['mousedown', 'touchstart'];
export const useClickOutside = (containerRef, callback) => {
    const { document } = useContext(FrameContext);
    useEffect(() => {
        if (!document) {
            return;
        }
        const handleClickOutside = (e) => {
            const target = e.target || e.srcElement || e.currentTarget;
            if (containerRef.current && !containerRef.current.contains(target)) {
                callback();
            }
        };

        for (const eventName of defaultEvents) {
            document.addEventListener(eventName, handleClickOutside);
        }
        return () => {
            for (const eventName of defaultEvents) {
                document.removeEventListener(eventName, handleClickOutside);
            }
        };
    }, [callback, containerRef, document]);
};
